export enum AuthPopupKeys {
    AuthPopupSuccess = "AuthPopupSuccess",
    AuthPopupFailureReason = "AuthPopupFailureReason"
};